module.exports = __webpack_public_path__ + "02_long_yellow.4fb6dd00.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/02_long_yellow.png
// module id = egJV
// module chunks = 0